import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  ComonExportPage,
  fetchSubmittedProposalsReport,
} from "./submittedProposalsReport.services";
import {
  submittedProposalsReportFetchSuccess,
  submittedProposalsReportFetchFailure,
  submittedProposalsReportFetchResponseChanged,
  submittedProposalsReportExportAllFailure,
  submittedProposalsReportExportAllSuccess,
  submittedProposalsReportExportAllChanged,
} from "./submittedProposalsReport.action";
import SubmittedProposalsReportTypes from "./submittedProposalsReport.types";

/** *********************** START SUBMITTED PROPOSALS REPORT LIST ************************ */
export function* SubmittedProposalsReportListFetch({ payload }: any) {
  const key: any = "SubmittedProposalsJsonKey";
  const {
    FromDate,
    ToDate,
    CompanyID,
    InstanceName,
    UserID,
    UserLevel,
    Limit,
    BranchID,
  } = payload;
  try {
    const jsonData: any = {
      FromDate: FromDate,
      ToDate: ToDate,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
      UserID: UserID,
      UserLevel: UserLevel, // role-based lead-source isolation (backend fail-safe)
      Limit: Limit || 0,
      BranchID: BranchID,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchSubmittedProposalsReport, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(submittedProposalsReportFetchFailure(responseData.data));
    } else {
      yield put(submittedProposalsReportFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(submittedProposalsReportFetchFailure(error));
  }
}

export function* submittedProposalsReportFetchReset() {
  yield put(submittedProposalsReportFetchResponseChanged());
}

export function* onFetchListSubmittedProposalsReport() {
  yield takeLatest(
    SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_START,
    SubmittedProposalsReportListFetch,
  );
}

export function* onSubmittedProposalsReportResponseReset() {
  yield takeLatest(
    SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_RESET_START,
    submittedProposalsReportFetchReset,
  );
}

/** *********************** END SUBMITTED PROPOSALS REPORT LIST ************************ */

/** *********************** START SUBMITTED PROPOSALS REPORT EXPORT LIST ************************ */
export function* submittedProposalsReportListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  const {
    BranchID,
    IsFresh,
    ConditionExec,
    URL,
    CreateDateTime,
    RequestReportPage,
    CompanyID,
    RequestedBy,
    FromDate,
    ToDate,
    MemberID,
    DateType,
    InstanceName,
  } = payload;
  try {
    const jsonData: any = {
      BranchID: BranchID,
      IsFresh: IsFresh,
      ConditionExec: ConditionExec,
      ExistRequestID: 1,
      CreateDateTime: CreateDateTime,
      RequestReportPage: RequestReportPage,
      CompanyID: CompanyID,
      RequestedBy: RequestedBy,
      URL: URL,
      FromDate: FromDate,
      ToDate: ToDate,
      MemberID: MemberID,
      DateType: DateType,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(submittedProposalsReportExportAllFailure(responseData.data));
    } else {
      yield put(submittedProposalsReportExportAllSuccess(responseData.data));
    }
  } catch (error) {
    yield put(submittedProposalsReportExportAllFailure(error));
  }
}

export function* submittedProposalsReportExportAllReset() {
  yield put(submittedProposalsReportExportAllChanged());
}

export function* onExportListSubmittedProposalsReport() {
  yield takeLatest(
    SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_START,
    submittedProposalsReportListExport,
  );
}

export function* onSubmittedProposalsReportExportReset() {
  yield takeLatest(
    SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_RESET_START,
    submittedProposalsReportExportAllReset,
  );
}

/** *********************** END SUBMITTED PROPOSALS REPORT EXPORT LIST ************************ */

export function* submittedProposalsReportSaga() {
  yield all([
    call(onSubmittedProposalsReportResponseReset),
    call(onFetchListSubmittedProposalsReport),
    call(onExportListSubmittedProposalsReport),
    call(onSubmittedProposalsReportExportReset),
  ]);
}
